
import { Col, Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { storeIncidentLabel, getIncidentLabel, getNMBSLoginSelection } from '../storage/selectionStorage';

function IncidentDropdown(props) {
    console.log("Incident Label props", props);
    const localStorageTrustBuilder = JSON.parse(localStorage.getItem("trustBuilder"));

    const [selectedIncident, setSelectedIncident] = useState((localStorageTrustBuilder && getIncidentLabel() && getNMBSLoginSelection()) ? getIncidentLabel()[0].incidentTypeLabel : "")
    const [selectedIncidentId, setSelectedIncidentId] = useState((localStorageTrustBuilder && getIncidentLabel() && getNMBSLoginSelection()) ? getIncidentLabel()[0].incidentId : "")

    const setFirstValue = () => {
        // getTrustBuilder Value.
        let trustBuilder = localStorage.getItem("trustBuilder");
        if (!trustBuilder) {
            return;
        }

        if (props.array.length === 1) {
            console.log("props.array is", props.array);
            // Get First index of the array
            const firstValue = props.array[0];
            console.log("props.array firstValue", firstValue);
                            

            props.callbackfunc(firstValue.incidentTypeLabel, firstValue.incidentId,firstValue.isVandalismEnabled ? true : false);
            setSelectedIncident(firstValue.incidentTypeLabel);
            setSelectedIncidentId(firstValue.incidentId);
        }
    }

    useEffect(() => {
	setSelectedIncident(props.incidentType || "");
}, [props.incidentType]);

    useEffect(() => {
        console.log("incidentArray in useEffect", props.array);
        const incidentLabel = getIncidentLabel();
        if (incidentLabel) {
            const localStorageTrustBuilder = JSON.parse(localStorage.getItem("trustBuilder"));
            if (localStorageTrustBuilder && getNMBSLoginSelection()) {
                setSelectedIncident(incidentLabel[0].incidentTypeLabel);
            }
        }
    }, []);

    useEffect(() => {
        console.log("selectedIncidentId in useEffect", selectedIncidentId);
        setSelectedIncidentId(getIncidentLabel() ? getIncidentLabel()[0].incidentId : "")
        setSelectedIncident(getIncidentLabel() ? getIncidentLabel()[0].incidentTypeLabel : "")

        const getIncidentFromArray = async () => {
            const incidentId = selectedIncidentId;
            if (incidentId) {
                if (props.array.length === 1) {
                    setFirstValue();
                } else {
                    {
                        props.array && props.array.map((incident) => {
                            console.log("incidentId in mapping array", incident, incidentId);
                            if (incidentId === incident.incidentId) {
                                setSelectedIncident(incident.incidentTypeLabel);
                                // Trigger callback to notify parent about incident selection and WiFi antenna logic
                                props.callbackfunc(
                                    incident.incidentTypeLabel,
                                    incident.incidentId,
                                    incident.isVandalismEnabled ? true : false
                                );
                            }
                        })
                    }
                }
            }
            else {
                setFirstValue()
            }
        }

        getIncidentFromArray()
    }, [props.langCode, props.array])

    const handleIncidentType = (e) => {
        console.log("selectedValue handleIncidentType", e);
        const selectedValue = e.target.value;
        console.log("selectedValue handleIncidentType", selectedValue);
        if (selectedValue.length <= 0) {
            return props.callbackfunc(selectedValue);
        }
        const value = props.array.filter(function (item) {
            return item.incidentTypeLabel == e.target.value
        })
        if (value) {
            console.log("selectedValue,value[0].incidentId", selectedValue, value[0]);
            storeIncidentLabel(value);
            props.callbackfunc(
                selectedValue,
                value[0].incidentId,
                value[0].isVandalismEnabled ? true : false
            ); 
            setSelectedIncident(selectedValue); // Update state on selection
            setSelectedIncidentId(value[0].incidentId);
        }
    }
    console.log("selectedIncident after set value", selectedIncident);
    return (
        <Form.Group as={Col} className="form-group">
            <Form.Label className="form-label"> {props.label} <span style={{ color: 'red' }}>*</span> :</Form.Label>
            <Form.Select role="dropdown" value={selectedIncident} data-testid="incident-dropdown-child" aria-label="" className="complaint-select" disabled={props.incidentDisabled} onChange={(e) => { handleIncidentType(e) }}>
                <option value=""></option>
                {props.array && props.array.map((incident) => {
                    return <option className='option' value={incident.incidentTypeLabel} key={incident.incidentId}>{incident.incidentTypeLabel}</option>
                })}
            </Form.Select>
        </Form.Group>
    )
}

IncidentDropdown.propTypes = {
    array: PropTypes.arrayOf(PropTypes.object),
    callbackfunc: PropTypes.func,
    incidentType: PropTypes.string,
    langCode: PropTypes.string,
    label: PropTypes.string,
    incidentDisabled: PropTypes.bool,
};

export default IncidentDropdown;